// txnLiveMerge.js — an EOI / Deals list re-reads ONE LEAD's rows, not the book (P2, 2026-11-02)
//
// Until P2 the two transaction lists had no row-level live path for OTHER
// users' changes: a lead_updated frame bumped cbBust, a 30s throttle fired,
// and the page re-walked the ENTIRE book through fetchAllPages (measured
// 2026-08-26: four full /api/deals rebuilds in 19s for one page view). Now the
// server sends `entity_changed { family:"eoi"|"deal", ids:[leadId…] }` for
// every record write and every lead / DR write that moves a transaction, and
// the page asks `GET /api/eois?leadIds=` (or /api/deals) for just those leads.
//
// mergeTxnRowsByLead(prev, fresh, leadIds, order): every held row whose LEAD
// is in leadIds is dropped, the fresh rows (the server's current answer for
// those leads — scope and tab filter already applied) are added, and the list
// is re-sorted with the page's own order. A lead the server no longer answers
// for (cancelled out of the tab, hard-deleted, moved out of scope) therefore
// disappears; a new record on a known lead appears. gid(row) is the LEAD's id
// on a record-backed row by design (rowFromTxnRecord copies the lead), which
// is exactly the key this merge needs.

export var TXN_LIVE_MAX_IDS = 50;

export function txnLiveUrl(kind, leadIds) {
  var ids = (leadIds || []).slice(0, TXN_LIVE_MAX_IDS).map(function (id) { return encodeURIComponent(String(id)); });
  return "/api/" + (kind === "deal" ? "deals" : "eois") + "?status=all&limit=500&leadIds=" + ids.join(",");
}

export function mergeTxnRowsByLead(prev, fresh, leadIds, order, gid) {
  var keyOf = gid || function (o) { return o ? String(o._id || o.id || "") : ""; };
  var drop = {};
  (leadIds || []).forEach(function (id) { drop[String(id)] = true; });
  var kept = (prev || []).filter(function (r) { return !drop[keyOf(r)]; });
  var seen = {};
  kept.forEach(function (r) { if (r && r._rowKey) seen[String(r._rowKey)] = true; });
  (fresh || []).forEach(function (r) {
    if (!r) return;
    if (r._rowKey && seen[String(r._rowKey)]) return;   // never two rows for one record
    if (r._rowKey) seen[String(r._rowKey)] = true;
    kept.push(r);
  });
  return typeof order === "function" ? kept.sort(order) : kept;
}
